<template>
  <v-dialog
    v-model="dialog"
    :width="widthComponent"
    @click:outside="outsideClick"
  >
    <template #activator="{ on: dialog }">
      <v-tooltip
        open-delay="1000"
        :disabled="noToolTip"
        right
      >
        <template #activator="{ on: tooltip }">
          <v-btn
            v-if="!onlyIcon && !noBtn"
            :rounded="isRounded"
            :fab="isFab"
            :width="width"
            :height="height"
            :small="isSmall"
            :color="color"
            :style="btnStyle"
            :disabled="isButtonDisabled"
            class="dash-btn"
            @click="btnClick"
            v-on="{ ...tooltip, ...dialog }"
          >
            <v-icon>
              {{ btnIcon }}
            </v-icon>
            {{ btnText }}
          </v-btn>
          <v-btn
            v-else-if="onlyIcon && !noBtn"
            :class="getMargin"
            icon
            :style="btnStyle"
            :disabled="isButtonDisabled"
            v-on="{ ...tooltip, ...dialog }"
            @click="btnClick"
          >
            <v-icon
              :size="size"
              :color="colorIcon != '' ? colorIcon : iconColor"
            >
              {{ btnIcon }}
            </v-icon>
          </v-btn>
        </template>
        <img
          v-if="titleToolTip.includes('.gif')"
          class="mt-2"
          :src="titleToolTip"
        />
        <span v-else>{{ titleToolTip }}</span>
      </v-tooltip>
    </template>

    <v-card
      :loading="load ? '#C0C0C0' : null"
      :style="heightComponent"
    >
      <v-card-title v-if="titleDialog.length > 0">
        {{ titleDialog }}
      </v-card-title>
      <v-divider v-if="titleDialog.length > 0" />
      <v-card-text>
        <slot />
      </v-card-text>
      <v-divider v-if="actifBtnOK || actifBtnCancel" />
      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="actifBtnOK"
          text
          :disabled="isValidDisabled"
          @click="okPushed"
        >
          {{ $t("dialog.ok") }}
        </v-btn>
        <v-btn
          v-if="actifBtnCancel"
          text
          @click="cancelPushed"
        >
          {{ $t("dialog.cancel") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    widthDialog: {
      type: Number,
      default: 0,
    },
    titleDialog: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: undefined,
    },
    height: {
      type: String,
      default: undefined,
    },
    load: {
      type: Boolean,
      default: false,
    },
    noBtn: {
      type: Boolean,
      default: false,
    },
    actifBtnOK: {
      type: Boolean,
      default: true,
    },
    actifBtnCancel: {
      type: Boolean,
      default: true,
    },
    on: {
      type: Boolean,
      default: false,
    },
    btnIcon: {
      type: String,
      default: "",
    },
    btnText: {
      type: String,
      default: "",
    },
    btnStyle: {
      type: String,
      default: "",
    },
    isRounded: {
      type: Boolean,
      default: true,
    },
    isFab: {
      type: Boolean,
      default: false,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "",
    },
    colorIcon: {
      type: String,
      default: "",
    },
    titleToolTip: {
      type: String,
      default: "",
    },
    onlyIcon: {
      type: Boolean,
      default: false,
    },
    isValidDisabled: {
      type: Boolean,
      default: false,
    },
    isButtonDisabled: {
      type: Boolean,
      default: false,
    },
    isSchedule: {
      type: Boolean,
      default: false,
    },
    noToolTip: {
      type: Boolean,
      default: true,
    },
    dialogViewer: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 25,
    },
  },
  data() {
    return {
      dialog: false,
      iconColor: "white",
    };
  },
  computed: {
    getMargin() {
      if (this.size > 35) {
        return "my-2";
      } else {
        return "my-0";
      }
    },
    heightComponent() {
      if (this.isSchedule) {
        return "height: 75vh";
      } else {
        return "height: 500";
      }
    },
    widthComponent() {
      if (this.isSchedule && this.widthDialog == 0) {
        return "75vw";
      } else if (this.widthDialog == 0) {
        return "550";
      } else {
        return this.widthDialog;
      }
    },
  },
  watch: {
    dialog: function () {
      if (this.dialog) {
        this.click = this.dialog;
        this.$store.dispatch("dialogOpen").creation;
      } else {
        this.$store.dispatch("dialogClose").creation;
      }
    },
    dialogViewer: function (val) {
      this.dialog = val;
    },
  },
  methods: {
    btnClick() {
      this.iconColor = "#8c8c8c";
      this.$emit("btn-click");
    },
    cancelPushed() {
      this.dialog = false;
      this.iconColor = "white";
      this.$emit("cancel-pushed");
      this.$emit("update:dialog-viewer", false);
    },
    okPushed() {
      this.dialog = false;
      this.iconColor = "white";
      this.$emit("ok-pushed");
      this.$emit("update:dialog-viewer", false);
    },
    openDialog() {
      this.dialog = true;
    },
    outsideClick() {
      this.$emit("outside-click");
      this.$emit("update:dialog-viewer", false);
    },
  },
};
</script>

<style></style>
